var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"value":_vm.selectedDeviceId,"label":_vm.label,"items":_vm.deviceOptions,"disabled":_vm.disabled},on:{"input":_vm.deviceSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }